import clsx from 'clsx'
import React, { CSSProperties, FC } from 'react'

import styles from './Spinner.module.scss'

export interface SpinnerProps{
  className?: string
  style?: CSSProperties
}

export const Spinner: FC<SpinnerProps> = ({ className, style }) => <div className={clsx(styles.spinner, className)} style={style} />
